import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { AuditLog, PaginatedResponse } from '../types';

interface AuditLogsParams {
    page?: number;
    per_page?: number;
    action?: string;
    resource_type?: string;
    from?: string;
    to?: string;
}

export const useAuditLogs = (params: AuditLogsParams = {}) => {
    return useQuery({
        queryKey: ['audit-logs', params],
        queryFn: async () => {
            const searchParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    searchParams.append(key, String(value));
                }
            });

            const { data } = await api.get<{
                success: boolean;
                data: AuditLog[];
                meta: PaginatedResponse<AuditLog>['meta'];
            }>(`/audit-logs?${searchParams}`);

            return { data: data.data, meta: data.meta };
        },
    });
};
